module.exports = __webpack_public_path__ + "media/images/athletes/4143-734b0a8afec33bae067ce911da7dfffb.png";